import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PersonService = /** @class */ (function () {
    function PersonService(http) {
        this.http = http;
    }
    PersonService.prototype.getPersonByCUIT = function (doumentId) {
        return this.http.get(environment.server.api.contactManager + "/api/person/cuit?DocumentNumber=" + doumentId).pipe(map(function (response) { return response && response.data; }));
    };
    PersonService.prototype.getPersonsByCUIT = function (data) {
        return this.http.post(environment.server.api.contactManager + "/api/person/PersonsByCuit", data);
    };
    PersonService.prototype.personsByDni = function (data) {
        return this.http.post(environment.server.api.contactManager + "/api/person/PersonsByDni", data);
    };
    PersonService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PersonService_Factory() { return new PersonService(i0.ɵɵinject(i1.HttpClient)); }, token: PersonService, providedIn: "root" });
    return PersonService;
}());
export { PersonService };
